/**
 * Permissions shared by a sidebar entry and its route, kept apart from the
 * nav map so the router can import them without pulling in every icon.
 */

/**
 * What the home screen needs to show anything at all: the business, the sales
 * tiles, the stock alerts or the product cards. Without one of these the page
 * is a greeting over empty cards, so the sidebar hides it and the page sends
 * the person on to `firstAllowedPath` instead.
 */
export const DASHBOARD_PERMISSION = 'TENANT_READ|ANALYTICS_READ|INVENTORY_READ|PRODUCT_READ';

/** Every permission some report is gated on (`backend/app/services/reporting`). */
export const REPORTS_PERMISSION =
  'ORDER_READ|PRODUCT_READ|INVENTORY_READ|CUSTOMER_READ|MARKETING_READ|ANALYTICS_READ';
